module.exports = __webpack_public_path__ + "static/media/logo.b2b8d556.svg";